import { render, staticRenderFns } from "./ChessPiece.vue?vue&type=template&id=4fe1c54e&scoped=true&"
import script from "./ChessPiece.vue?vue&type=script&lang=js&"
export * from "./ChessPiece.vue?vue&type=script&lang=js&"
import style0 from "./ChessPiece.vue?vue&type=style&index=0&id=4fe1c54e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe1c54e",
  null
  
)

export default component.exports